import { query, where, collection } from "firebase/firestore";
import { db } from "../firebase";

export const allProjectsQuery = (communityCode) => query(
  collection(db, "projects"),
  where("communityCode", "==", communityCode)
);

// Derive a normalized status for any project (handles old data without status field)
export const deriveStatus = (project) => {
  if (project.status) return project.status;
  return project.active ? "in-progress" : "open";
};
